import { useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SLOTS = ["09:00","09:30","10:00","10:30","11:00","11:30","13:00","13:30","14:00","14:30","15:00","15:30","16:00","16:30"];

export function BookingModal({ open, onClose, initial }) {
  const [form, setForm] = useState({ name: "", email: "", date: "", time: "10:00", note: "" });
  const [status, setStatus] = useState("");
  const [busy, setBusy] = useState(false);
  const [prefilled, setPrefilled] = useState(false);

  if (open && initial && !prefilled) {
    setForm((f) => ({ ...f, name: initial.name || "", email: initial.email || "", note: initial.note || "" }));
    setPrefilled(true);
  }
  if (!open && prefilled) setPrefilled(false);

  if (!open) return null;

  const tomorrow = new Date(Date.now() + 86400000);
  const minDate = tomorrow.toISOString().slice(0, 10);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setStatus("Sending your request…");
    try {
      const res = await fetch(`${API}/bookings`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...form, website: "" }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Please check the details and try again.");
      setStatus("Thank you — your consultation request was received. We will reply to confirm the time and send a meeting link.");
      setForm({ name: "", email: "", date: "", time: "10:00", note: "" });
    } catch (err) {
      setStatus(err.message || "The request could not be sent. Please email ronald.scott.digitalstaticllc@gmail.com instead.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="modal-overlay" data-testid="booking-modal" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="bookingTitle">
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="modal-close" data-testid="booking-close" onClick={onClose} aria-label="Close">✕</button>
        <span className="mono-label" style={{color:'#0f766e',display:'block',marginBottom:'10px'}}>15-minute consultation · video call</span>
        <h3 id="bookingTitle">{initial ? "Propose a new time" : "Schedule a consultation"}</h3>
        <p className="sub">{initial
          ? "Your details are prefilled — just pick a new date and time (US Eastern). We confirm every request personally by email."
          : "Pick a date and time (US Eastern). We confirm every request personally by email — nothing is booked automatically."}</p>
        <form onSubmit={submit}>
          <div className="contact-fields">
            <label className="modal-label">Your name *<input className="modal-input" data-testid="booking-name" required autoComplete="name" value={form.name} onChange={set("name")} /></label>
            <label className="modal-label">Work email *<input className="modal-input" data-testid="booking-email" type="email" required autoComplete="email" value={form.email} onChange={set("email")} /></label>
          </div>
          <div className="contact-fields">
            <label className="modal-label">Preferred date (Mon–Fri) *<input className="modal-input" data-testid="booking-date" type="date" required min={minDate} value={form.date} onChange={set("date")} /></label>
            <label className="modal-label">Preferred time (ET) *
              <select className="modal-input" data-testid="booking-time" value={form.time} onChange={set("time")}>
                {SLOTS.map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
            </label>
          </div>
          <label className="modal-label">What should we focus on?<textarea className="modal-input" data-testid="booking-note" rows={2} maxLength={1000} placeholder="Optional — e.g. upcoming software rollout" value={form.note} onChange={set("note")} /></label>
          <button className="btn btn-primary" data-testid="booking-submit" type="submit" disabled={busy} style={{width:'100%',padding:'15px'}}>
            {busy ? "Sending…" : "Request this time ↗"}
          </button>
          <div className="form-status" data-testid="booking-status" role="status" aria-live="polite" style={{color: status.startsWith("Thank you") ? '#0f766e' : '#b42318'}}>{status}</div>
        </form>
      </div>
    </div>
  );
}
